import { useState } from "react";
import { format, startOfDay, endOfDay, subDays } from "date-fns";
import { CalendarBlank } from "@phosphor-icons/react";
import { Button } from "./ui/button";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

const PRESETS = [
  { key: "today", label: "Today", range: () => ({ from: startOfDay(new Date()), to: endOfDay(new Date()) }) },
  { key: "7d", label: "7D", range: () => ({ from: startOfDay(subDays(new Date(), 6)), to: endOfDay(new Date()) }) },
  { key: "30d", label: "30D", range: () => ({ from: startOfDay(subDays(new Date(), 29)), to: endOfDay(new Date()) }) },
];

export function DateRangePicker({ value, onChange, testId = "date-range" }) {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(null);

  const label = value?.from
    ? `${format(value.from, "dd MMM")} – ${format(value.to ?? value.from, "dd MMM yyyy")}`
    : "Custom";

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={testId}>
      <Button
        variant={!value ? "default" : "outline"}
        size="sm"
        data-testid={`${testId}-all`}
        onClick={() => onChange(null)}
      >
        All time
      </Button>
      {PRESETS.map((p) => (
        <Button
          key={p.key}
          variant="outline"
          size="sm"
          data-testid={`${testId}-${p.key}`}
          onClick={() => onChange(p.range())}
        >
          {p.label}
        </Button>
      ))}
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button variant="outline" size="sm" data-testid={`${testId}-custom`}>
            <CalendarBlank className="mr-2 h-4 w-4" />
            {label}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="end">
          <Calendar
            mode="range"
            numberOfMonths={2}
            selected={draft}
            onSelect={setDraft}
            data-testid={`${testId}-calendar`}
          />
          <div className="flex justify-end gap-2 p-3 border-t border-border">
            <Button variant="ghost" size="sm" data-testid={`${testId}-cancel`} onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button
              size="sm"
              data-testid={`${testId}-apply`}
              disabled={!draft?.from}
              onClick={() => {
                onChange({ from: startOfDay(draft.from), to: endOfDay(draft.to || draft.from) });
                setOpen(false);
              }}
            >
              Apply
            </Button>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}
